import React from 'react'

import {
  Grid,
  Typography,
} from '@mui/material'

const LandingWho = (props) => {
  return (
    <Grid container spacing={2} p={4} py={8} sx={{ bgcolor: 'white' }}>
      <Grid item xs={12}>
        <Typography align='center' color='primary' variant='h3' gutterBottom>
          <b style={{ fontWeight: 900 }}>¿Quiénes somos?</b>
        </Typography>
        <Typography align='center' color='#00c08b' variant='h5' gutterBottom>
          <b style={{ fontWeight: 700 }}>Todos en una misma ruta</b>
        </Typography>
        <Typography align='center' variant='body1'>
          <b style={{ fontWeight: 700 }}>Light Spot®</b>, nace de la necesidad de mejorar el sistema educativo y facilitar el seguimiento del alumno, los padres de familia y la capacitación de los preceptores. Creemos en la importancia de la preceptoría y vemos la necesidad de fortalecerla.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default LandingWho